import { buildLocalBusinessSchema } from '../types/LocalBusiness'

/**
 * Generates LocalBusiness schema for GrandChildPage
 * @param {Object} data - Page data object from appContext
 * @returns {Object|null} LocalBusiness schema object or null if LocationDetailsBlock not found
 */
export default function GrandChildPageSchema(data) {
    if (!data) {
        return null
    }

    const locationBlock = data.LocationDetailsBlock

    //Only build schema if LocationDetailsBlock exists
    if (locationBlock) {
        //Extract URL from data.Url if available, otherwise use window.location.href (client-side only)
        let url = data.Url?.Href || null
        if (!url && typeof window !== 'undefined') {
            url = window.location.href
        }
        
        //Build options object for LocalBusiness schema
        const options = {
            Name: locationBlock.Name,
            Url: url
        }

        //Build and return the LocalBusiness schema
        return buildLocalBusinessSchema(locationBlock, options)
    }

    //Space to add other schema generators for this page type later

    //Return null if no schema can be built
    return null
}